import { DatePickerProps } from 'antd';
import {
  Controller,
  FieldPath,
  FieldValues,
  useFormContext,
} from 'react-hook-form';
import { DatePicker } from '../../components';
import { DATE_FORMAT, getDayjs, ISO_DATE_FORMAT } from '../../utils';
import { useAdditionalFormContext } from '../AdditionalFormContext';
import { useGetIdFromName } from '../utils';
import { FORM_DATE_PICKER_POPUP_CLASSNAME } from './constants';

export interface FormDatePickerProps<
  FormData extends FieldValues,
  Name extends FieldPath<FormData> = FieldPath<FormData>,
> extends DatePickerProps {
  name: Name;
  valueFormat?: string;
}

export const FormDatePicker = <
  FormData extends FieldValues,
  Name extends FieldPath<FormData>,
>(
  props: FormDatePickerProps<FormData, Name>,
) => {
  const getIdFromName = useGetIdFromName();
  const {
    name,
    id = getIdFromName(name),
    valueFormat = ISO_DATE_FORMAT,
    format = DATE_FORMAT,
    ...rest
  } = props;
  const { control } = useFormContext<FormData>();
  const { onChange: formOnChange } = useAdditionalFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => (
        <DatePicker
          {...rest}
          id={id}
          format={format}
          onChange={(date, dateString) => {
            const value = (date as any)?.format(valueFormat) ?? null;
            onChange({
              target: { value },
            });
            rest.onChange?.(date, dateString);
            formOnChange?.();
          }}
          classNames={{
            popup: { root: FORM_DATE_PICKER_POPUP_CLASSNAME },
          }}
          value={value ? getDayjs(value, valueFormat) : null}
        />
      )}
    />
  );
};
